"use client";

import { IProduct } from "@faire/web-api--source/indigofair/data/IProduct";
import { IQuickAdd } from "@faire/web-api--source/indigofair/data/IQuickAdd";

import { canAddToCart } from "@faire/retailer/lib/canAddToCart";

/**
 * Extracted this to a function since `canAddToCart` is using client retailer store.
 */
export const canQuickAdd = (
  state?: keyof typeof IProduct.State | undefined,
  quickAdd?: IQuickAdd
) => {
  const isSalesPaused = state === IProduct.State.SALES_PAUSED;

  const availableUnits =
    quickAdd?.quick_add_option?.option_available_units ??
    Number.POSITIVE_INFINITY;

  return canAddToCart() && !isSalesPaused && availableUnits !== 0;
};
